import { store } from "@src/redux/store";

export const getBaseUrl = () => {
  const {REACT_APP_BASE_API_PROTOCOL, REACT_APP_BASE_API_DOMAIN} = process.env;
  return `${REACT_APP_BASE_API_PROTOCOL}${REACT_APP_BASE_API_DOMAIN}`;
};

export const getUserToken = () => {
  const {access_token} = store.getState().loginUser;
  return access_token;
};
export const getRefreshToken = () => {
  const {refresh_token} = store.getState().loginUser;
  return refresh_token;
};

export const getIsUserLoggedIn = () => {
  return Boolean(store.getState().loginUser?.isLogin);
};
